import { Box, Grid } from "@mui/material";
import Panel from "../../../ProductAnalyzer/partials/QuickInfoCard/Panel";
import { Tooltip } from "../../../../components";
import { formatNumber } from "../../../../helpers";
import { useAppSelector } from "../../../../store/hooks";
import { selectProductAnalyzerSettings } from "../../../../features/settings/settings.selector";
import { getBsrDisplay } from "../../../ProductAnalyzer/partials/QuickInfoCard";

interface IProductMetricsProps {
  product: {
    estimatedSales: number;
    eligible: boolean;
    bsr: number;
    categoryProductCount: number;
  };
}

const ProductMetrics = ({ product }: IProductMetricsProps) => {
  const { minBsr, maxBsr } = useAppSelector(selectProductAnalyzerSettings);

  const bsrPercent = Math.ceil(
    (product.bsr / product.categoryProductCount) * 100,
  );

  return (
    <Grid
      container
      spacing={0.5}
      columns={{ xs: 3, sm: 4, md: 6, lg: 8, xl: 10 }}
      mt={0.5}
    >
      <Grid size={1}>
        <Panel
          title="Est. Sales"
          variant={product.estimatedSales > 0 ? "info" : "fail"}
        >
          <Tooltip
            title={
              product.estimatedSales > 0 ? (
                <>
                  &#x2139;&#xFE0F; Estimated monthly sales{" "}
                  {formatNumber(product.estimatedSales, {
                    forcePlusSuffix: true,
                  })}
                </>
              ) : (
                <>
                  &#x26A0;&#xFE0F; We do not have enough data points to estimate
                  the sales of this product
                </>
              )
            }
          >
            <Box>
              {formatNumber(product.estimatedSales, {
                forcePlusSuffix: true,
              })}
              /mo
            </Box>
          </Tooltip>
        </Panel>
      </Grid>
      <Grid size={1}>
        <Panel title="Eligible" variant={product.eligible ? "success" : "fail"}>
          <Tooltip
            title={
              product.eligible ? (
                <>&#x1F44D; You are eligible to sell this product.</>
              ) : (
                <>&#x1F44E; You are not eligible to sell this product.</>
              )
            }
          >
            <Box>{product.eligible ? "Yes" : "No"}</Box>
          </Tooltip>
        </Panel>
      </Grid>
      <Grid size={1}>
        <Panel
          title="BSR"
          variant={
            bsrPercent >= minBsr && bsrPercent <= maxBsr ? "success" : "fail"
          }
        >
          {product.bsr > 0 ? (
            <Box>
              {getBsrDisplay(product.bsr, product.categoryProductCount)}
            </Box>
          ) : (
            <Tooltip
              title={<>&#x26A0;&#xFE0F; We do not know BSR of this product.</>}
              arrow
            >
              <Box>Unknown</Box>
            </Tooltip>
          )}
        </Panel>
      </Grid>
    </Grid>
  );
};

export default ProductMetrics;
